const TEXT_CONSTANTS = {
    VENUE: "Venue",
    HOME_ADDRESS: "Home Address",
    EMAIL_ID: "Email ID",
    MOBILE_NUMBER: "Mobile Number",
    RESCHEDULE: "RESCHEDULE",
    APPLICATION_NO: "Application No. "
}

export default TEXT_CONSTANTS;